export const DATADOG_USER_AGENT_REGEX = /Datadog\/?Synthetics$/;
